module.exports = __webpack_public_path__ + "static/media/no-image-available.fd6fd972.png";